define([
        "dojo/_base/lang",
        "MW/toolstrip/hashes/componentproperties/properties/TagProperty",
        "MW/toolstrip/hashes/componentproperties/properties/TypeProperty",
        "./RegionProperty",
        "../TypeConstants"
    ],
    function (lang, TagProperty, TypeProperty, RegionProperty, TypeConstants) {
        var hash = {};

        hash[TypeConstants.STATUS_GROUP] = lang.mixin({}, TagProperty, TypeProperty, RegionProperty);

        return hash;
    });
